import { useContext } from 'react';
import { PdfContext } from 'utils/context';
import CultureListTable from '../Tables/CultureListTable';

const CultureListConventional = () => {
  const { cultures } = useContext(PdfContext);

  const numberOfRowPerTable = 10;
  let slicedCultureTable = [];

  for (let i = 0; i < cultures.length; i += numberOfRowPerTable) {
    slicedCultureTable.push(cultures.slice(i, i + numberOfRowPerTable));
  }

  return (
    <div>
      {slicedCultureTable.map((data, index) => (
        <CultureListTable
          key={index}
          truncatedCultures={data}
          messageDuplicate={index > 0 ? '(Suite)' : ''}
          isOrganic={false}
        />
      ))}
    </div>
  );
};

export default CultureListConventional;
